import { Text } from '@cuemath/web-comps';
import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { Button, Col, FlexView, Row, Separator } from '@cuemath/comps';
import BallLoader from 'comps/ball-loader';
import LAYOUT from 'constants/layout';
import { Message } from 'modules/form';
import { useStudentCourseDowngradePost } from '../../api/student-course-downgrade';

const Wrapper = styled(FlexView)`
  padding: 40px 10px 20px;
`;

const Point = styled(Text)`
  margin: 12px 0px;
`;

const Info = styled(Row)`
  margin: 20px 0px;
`;

const StudentCourseDowngradeInfo = ({ studentCourse }) => {
  const [successMessage, setSuccessMessage] = useState('');
  const [error, setError] = useState('');
  const history = useHistory();
  const { id: studentCourseId } = studentCourse || {};
  const onPostComplete = (error, response) => {
    if (error) {
      setError(error);
    } else if (response) {
      const { data } = response;
      if (data === 'downgrade successful') {
        setSuccessMessage('Downgrade Complete');
      }
    }
  };

  useEffect(() => {
    if (successMessage) {
      const timeoutId = setTimeout(() => {
        history.go(0);
      }, 2000);

      return () => {
        clearInterval(timeoutId);
      };
    }
  }, [history, successMessage]);

  const { post: postDowngradeRequest, isProcessing } = useStudentCourseDowngradePost({
    onComplete: onPostComplete,
  });

  const confirmDowngrade = useCallback(() => {
    postDowngradeRequest(
      {
        action: 'initiate_downgrade_process',
        action_data: {
          downgrade_type: 'hybrid_to_regular',
        },
      },
      {
        studentCourseId,
      },
    );
  }, [postDowngradeRequest, studentCourseId]);

  return (
    <Wrapper alignItems="center" justifyContent="space-between">
      {isProcessing ? (
        <Col>
          <BallLoader />
          <Text variant="body1Medium" align="center">
            Please do not refresh
          </Text>
        </Col>
      ) : (
        <Row gutter justifyContent="center">
          <Text variant="h5">Downgrade</Text>
          {error && (
            <Message width="100%" error>
              {error}
            </Message>
          )}
          <Separator height={LAYOUT.GAP} transparent />
          {successMessage && <Message width="100%">{successMessage}</Message>}
          <Info justifyContent="flex-start">
            <Separator height={LAYOUT.GAP} transparent />
            <Point variant="body1Medium" align="left">
              1. Downgrade is only allowed from Hybrid, Class K5 to Regular right now
            </Point>
            <Point variant="body1Medium" align="left">
              2. Downgrade is a one time activity
            </Point>
            <Point variant="body1Medium" align="left">
              3. The student will be given the same number of classes as they currently
              have in their hybrid course
            </Point>
          </Info>
          <Separator height={LAYOUT.GAP * 2} transparent />
          <Button
            align="center"
            label="Downgrade From Hybrid to Regular"
            onClick={confirmDowngrade}
            disabled={successMessage}
          />
        </Row>
      )}
    </Wrapper>
  );
};

export default StudentCourseDowngradeInfo;
